<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-03 16:37:13
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-16 15:42:51
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperativeShop\collaborateRules\viewRules\components\shopTable.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-table header-row-class-name="table-header-row" row-class-name="table-row" :data="list" ref="multipleTable">
			<el-table-column label="店铺名称" min-width="265">
				<template slot-scope="{ row }">
					<div class="flex-row flex-align-center">
						<platform-icon style="flex-shrink: 0" :platformId="row.platform_id" />
						<span class="ml-4">{{ row.shopName | formatEmpty }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="店铺ID" min-width="265">
				<template slot-scope="{ row }">
					<span>{{ row.outerShopId }}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="right">
				<template slot-scope="{ row }">
					<el-button type="text" @click="$refs.delShopDialog.show(row.outerShopId)">移除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 删除店铺 -->
		<del-shop-dialog ref="delShopDialog" :platformId="platformId" @refresh="$emit('refresh')" />
	</div>
</template>
<script>
import delShopDialog from './delShopDialog.vue';
export default {
	components: {
		delShopDialog,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {};
	},
};
</script>
